<template>
  <div>
    <a-card :bordered="false" title="辅助明细账">
      <a-alert v-if="missingCategories.length" type="warning" showIcon
        :message="`当前账套辅助类别不全（仅 ${dimensions.length} 类），缺失：${missingCategories.join('、')}。建议在【基础资料 → 辅助核算类别】补齐，或重建账套以加载模板 9 类。`"
        style="margin-bottom: 12px" />
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="辅助维度" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="categoryId" @change="onCategoryChange">
                  <a-select-option v-for="d in dimensions" :key="d.id" :value="d.id">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="核算对象" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="detailId" showSearch optionFilterProp="children" placeholder="选择明细" @change="searchQuery">
                  <a-select-option v-for="d in auxDetails" :key="d.id" :value="d.id">{{ d.name }}{{ d.code ? ' (' + d.code + ')' : '' }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="起始月份" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-month-picker v-model="beginMoment" format="YYYY-MM" style="width:100%" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="截止月份" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-month-picker v-model="endMoment" format="YYYY-MM" style="width:100%" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <store-tenant-select domain="finance" @change="handleStoreTenantChange"></store-tenant-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div v-if="materialInfo" style="margin-bottom: 12px;">
        <span style="margin-right: 24px;">编码：{{ materialInfo.code || '-' }}</span>
        <span style="margin-right: 24px;">名称：{{ materialInfo.name || '-' }}</span>
        <span style="margin-right: 24px;">规格：{{ materialInfo.standard || '-' }}</span>
        <span>单位：{{ materialInfo.unit || '-' }}</span>
      </div>
      <a-table bordered size="middle" rowKey="id" :columns="columns" :dataSource="dataSource" :pagination="false" :loading="loading" :scroll="tableScroll" />
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import { ledgerAuxDetail, auxiliaryCategoryList, auxiliaryDetailList, accountSetCurrent } from './api'
import StoreTenantSelect from '@/components/StoreTenantSelect'
export default {
  name: 'AuxDetailAccountList',
  components: { StoreTenantSelect },
  data() {
    return {
      labelCol: { span: 6 }, wrapperCol: { span: 17, offset: 1 },
      accountSetId: null, categoryId: undefined, detailId: undefined, beginMoment: null, endMoment: null, loading: false, dataSource: [], dimensions: [], auxDetails: [],
      tableScroll: { x: 'max-content', y: 400 },
      expectedCategories: ['客户','供应商','部门','职员','存货','项目','现金流','资金账户','仓库'],
      columns: [
        { title: '凭证号', dataIndex: 'voucher_no', width: 140,
          customRender: (text, row) => {
            if (row.word && row.code != null) return row.word + '-' + String(row.code).padStart(3, '0')
            return text
          } },
        { title: '日期', dataIndex: 'voucher_date', width: 110 },
        { title: '期间', dataIndex: 'period', width: 90 },
        { title: '摘要', dataIndex: 'summary' },
        { title: '借方', dataIndex: 'debit_amount', align: 'right', width: 110 },
        { title: '贷方', dataIndex: 'credit_amount', align: 'right', width: 110 },
        { title: '数量', dataIndex: 'qty', align: 'right', width: 90 },
        { title: '单价', dataIndex: 'unit_price', align: 'right', width: 90 },
        { title: '余额数量', dataIndex: 'balanceQty', align: 'right', width: 100 }
      ]
    }
  },
  computed: {
    missingCategories() {
      const present = this.dimensions.map(d => d.name)
      return this.expectedCategories.filter(n => !present.includes(n))
    },
    materialInfo() {
      const cat = this.dimensions.find(d => d.id === this.categoryId)
      if (!cat || cat.source_table !== 'jsh_material') return null
      return this.auxDetails.find(d => d.id === this.detailId) || null
    }
  },
  created() {
    this.beginMoment = moment()
    this.endMoment = moment()
    this.loadCurrent()
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$el.querySelector('.ant-table')
      if (el) {
        const top = el.getBoundingClientRect().top
        this.tableScroll.y = Math.max(300, window.innerHeight - top - 24)
      }
    })
  },
  methods: {
    loadCurrent() {
      accountSetCurrent({}).then((res) => {
        if (res && res.success && res.data && res.data.id) { this.accountSetId = res.data.id; this.loadCategories() } else { this.$message.warning('尚未建账') }
      })
    },
    loadCategories() {
      auxiliaryCategoryList({ accountSetId: this.accountSetId }).then((res) => {
        if (res && res.success) { this.dimensions = res.data || []; if (this.dimensions.length) { this.categoryId = this.dimensions[0].id; this.onCategoryChange() } }
      })
    },
    onCategoryChange() {
      this.detailId = undefined
      this.dataSource = []
      this.auxDetails = []
      if (!this.categoryId) return
      auxiliaryDetailList({ categoryId: this.categoryId }).then((res) => {
        if (res && res.success) this.auxDetails = res.data || []
      })
    },
    searchQuery() {
      if (!this.categoryId || !this.detailId) { this.$message.warning('请选择核算对象'); return }
      this.loading = true
      const beginPeriod = this.beginMoment ? this.beginMoment.format('YYYY-MM') : null
      const endPeriod = this.endMoment ? this.endMoment.format('YYYY-MM') : null
      ledgerAuxDetail({ categoryId: this.categoryId, detailId: this.detailId, beginPeriod: beginPeriod, endPeriod: endPeriod }).then((res) => {
        if (res && res.success) {
          const rows = (res.data || []).map((r, i) => ({ ...r, key: r.id || i }))
          if (rows.length > 0) {
            const sumDebit = rows.reduce((s, r) => s + (Number(r.debit_amount) || 0), 0)
            const sumCredit = rows.reduce((s, r) => s + (Number(r.credit_amount) || 0), 0)
            const balance = sumDebit - sumCredit
            // 数量余额：借方分录 +qty、贷方分录 −qty 逐行累计（与金额借差/贷差同口径；无数量分录时数量列留空）
            const hasQty = rows.some(r => r.qty !== null && r.qty !== undefined && r.qty !== '')
            let runQty = 0
            if (hasQty) {
              rows.forEach(r => {
                const q = Number(r.qty) || 0
                runQty = Math.round((runQty + ((Number(r.debit_amount) || 0) !== 0 ? q : -q)) * 1e6) / 1e6
                r.balanceQty = runQty
              })
            }
            rows.push({ key: 'subtotal', voucher_no: '本期合计', debit_amount: sumDebit.toFixed(2), credit_amount: sumCredit.toFixed(2), qty: hasQty ? runQty : undefined, _isAggRow: true })
            rows.push({ key: 'total', voucher_no: '累计余额', summary: (balance >= 0 ? '借差 ' : '贷差 ') + Math.abs(balance).toFixed(2), balanceQty: hasQty ? runQty : undefined, _isAggRow: true })
          }
          this.dataSource = rows
        } else if (res && res.message) {
          this.$message.warning(res.message)
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    searchReset() {
      this.detailId = undefined
      this.beginMoment = moment()
      this.endMoment = moment()
      this.dataSource = []
    },
    handleStoreTenantChange() { this.searchQuery() }
  }
}
</script>